// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type TaxPaths = paths;
export const TAX_SERVICE = "tax" as const;

/** Typed openapi-fetch client for the tax service (schema `tax`). */
export function createTaxClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("tax", options);
}

export type TaxClient = ReturnType<typeof createTaxClient>;
